import { Center } from "components/utils/Center";
import { LoadingSpinner } from "components/utils/LoadingSpinner";

export const Loading = () => (
    <Center>
        <LoadingSpinner />
    </Center>
);
